<template>
    <div class="container">
        <div class="feedback-list" @click="record">
            <div class="list-title">反馈记录</div>
            <img src="../assets/images/feedback-more.png" alt="" class="feedback-more">
        </div>
        <div class="feedback-main">
            <div class="mian-title">问题类型</div>
            <div class="main-content">
                <div class="feedback-classify">
                    <div :class="type=='产品建议'? 'classify-ac':'classify'" @click="choiceType('产品建议')">产品建议</div>
                    <div :class="type=='使用疑问'? 'classify-ac':'classify'" @click="choiceType('使用疑问')">使用疑问</div>
                    <div :class="type=='其他问题'? 'classify-ac':'classify'" @click="choiceType('其他问题')">其他问题</div>
                </div>
                <div class="details-title">详细说明</div>
                <div class="feedback-text-box">
                    <textarea  placeholder="请对您遇到的情况进行尽可能详细的说明" class="feedback-text" v-model="content"></textarea>
                </div>                
                <div class="update-title">图片上传<span>请提供问题相关的截图或照片</span></div>
                <div class="pic-list">
                    <div class="update-pic">
                        <input type="file" id="upgteimg" value="" @change="addPic"/>
                        <img src="../assets/images/uodate-pic.png" alt="">
                    </div>
                    <div class="pic-box" v-for="(item,index) in showPicList" :key="index">
                        <img :src="item" alt="" class="feedback-pic">
                        <img src="../assets/images/remove-pic.png" alt="" class="remove-pic" @click="removePic(index)">
                    </div>
                </div>
            </div>            
        </div>
        <div class="phone">
            <div class="phone-title">联系方式</div>
            <div class="phone-box">
                <input type="text" class="phone-num" placeholder="请输入联系方式" v-model="feedbackPhone">
            </div>            
        </div>
        <div class="sub" @click="sub">提交反馈</div>
    </div>
</template>
<script>
import {multer_pic,add_feedback} from '../api/my'
export default {
    data() {
        return {
            imei:'',
            type:'',
            content:'',
            showPicList:[],
            picList:[],
            feedbackPhone:'',
        };
    },
    computed: {},
    methods: {
        record(){
            this.$router.push('/feedback-record')
        },
        choiceType(type){
            this.type=type
        },
        addPic(){
            let dom=document.getElementById('upgteimg')
            let url = URL.createObjectURL(dom.files[0]);
            if(this.showPicList.length<1){
                this.showPicList.push(url);
                this.picList.push(dom.files[0])
            }else{
                this.$toast('最多可上传1张图片')
            }            
        },
        removePic(index){
            this.showPicList.splice(index,1)
            this.picList.splice(index,1)
        },
        sub(){
            if(this.type==''){
                return this.$toast('请选择类型')
            }
            if(this.content==''){
                return this.$toast('请输入详细说明')
            }
            if(this.feedbackPhone==''){
                return this.$toast('请输入联系方式')
            }
            const regex = /^1[3456789]\d{9}$/;
            if (!regex.test(this.feedbackPhone)){
                return this.$toast('请输入正确的手机号');    
            }           
            if(this.picList.length>0){
                var formData = new FormData();
                for (let i = 0; i < this.picList.length; i++) {
                    //此处文件名必须为 multerFile ，因为后台设置仅接口此文件名
                    formData.append('multerFile', this.picList[i]);
                }
                multer_pic(formData).then(res=>{
                    console.log(res)
                    if(res.status==200){
                        let upload=[];
                        console.log(res)
                        res.data.fileList.forEach(item=>{
                            upload.push(item.filename)
                        })
                        let picArr=JSON.stringify(upload)
                        let upload_time=parseInt(new Date().getTime()/1000)                        
                        add_feedback(this.imei,this.feedbackPhone,this.type,this.content,picArr,upload_time).then(res=>{
                            if(res.status==200){
                                this.$toast('提交成功')
                                this.$router.push('/my')
                            }
                        })
                    }
                })
            }else{
                let picArr=JSON.stringify([])
                let upload_time=parseInt(new Date().getTime()/1000)
                add_feedback(this.imei,this.feedbackPhone,this.type,this.content,picArr,upload_time).then(res=>{
                    if(res.status==200){
                        this.$toast('提交成功')
                        this.$router.push('/my')
                    }
                })
            }          
        }
    },
    created() {
        let imei=localStorage.getItem('imei');
        this.imei=imei;
    },
};
</script>
<style lang='less' scoped>
.container{
    padding: 16px;
}
.feedback-list{
    height: 60px;
    background-color: #fff;
    border-radius: 10px;
    padding: 0px 12px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
}
.list-title{
    height: 60px;
    line-height: 60px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
}
.feedback-more{
    display: block;
    height: 16px;
    margin-top: 22px;
}
.feedback-main{
    background-color: #fff;
    border-radius: 10px;
}
.mian-title{
    height: 50px;
    line-height: 50px;
    border-radius: 10px 10px 0px 0px;
    background-color: #FBFCFC;
    padding: 0px 12px;
}
.main-content{
    padding: 12px;
}
.feedback-classify{
    height: 32px;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;
}
.classify{
    height: 32px;
    line-height: 32px;
    background-color: #F2F6F6;
    text-align: center;
    font-size: 14px;
    color: #333;
    padding: 0px 10px;
    margin-right: 10px;    
}
.classify-ac{
    height: 32px;
    line-height: 32px;
    background-color: #01D6D6;
    text-align: center;
    font-size: 14px;
    color: #fff;
    padding: 0px 10px;
    margin-right: 10px;
}
.details-title{
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin-bottom: 10px;
}
.feedback-text-box{
    padding: 12px;
    border-radius: 10px;
    border: 1px solid #F0F0F0;
    margin-bottom: 20px;
}
.feedback-text{
    display: block;
    width: 100%;
    height: 150px;
    line-height: 20px;
    font-size: 14px;
    border: none;
}
.update-title{
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 7px;
}
.update-title span{
    font-size: 12px;
    color: #999999;
    font-weight: 400;
    margin-left: 10px;
}
.pic-list{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.update-pic{
    height: 60px;
    width: 60px;
    border-radius: 4px;
    background-color: #e5f9f9;
    margin-right: 10px;
    position: relative;
    overflow: hidden;
}
#upgteimg{
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    opacity: 0;
}
.update-pic img{
    display: block;
    height: 20px;
    width: 20px;
    margin: 20px auto;
}
.pic-box{
    height: 60px;
    width: 60px;
    margin-right: 10px;
    position: relative;
}
.feedback-pic{
    display: block;
    height: 100%;
    width: 100%;
    border-radius: 4px;
}
.remove-pic{
    display: block;
    height: 20px;
    width: 20px;
    position: absolute;
    top: -5px;
    right: -5px;
}
.phone{
    padding: 12px;
    background-color: #fff;
    border-radius: 10px;
}
.phone-title{
    height: 20px;
    line-height: 20px;
    font-weight: 500;
    color: #333;
    font-size: 14px;
    margin-bottom: 10px;
}
.phone-box{
    height: 48px;
    border: 1px solid #F0F0F0;
    border-radius: 4px;
    padding: 0px 12px;
}
.phone-num{
    height: 48px;
    display: block;
    width: 100%;
    line-height: 48px;
    border: none;
    font-size: 14px;
    color: #333;
}
.sub{
    margin-top: 16px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 25px;
    background-color: #01D6D6;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
}
</style>